import React from "react";
import FeatherIcon from "feather-icons-react";

// Keuze bij een gewijzigde partnerprijs: geldt de nieuwe prijs ook voor
// aanvragen die nog open staan, of alleen voor nieuwe aanvragen vanaf nu?
// Waarden komen overeen met `priceScope` op de server.
export const PRICE_SCOPE_OPEN = "open";
export const PRICE_SCOPE_NEW = "new";

const OPTIONS = [
  {
    value: PRICE_SCOPE_OPEN,
    label: "Alle openstaande aanvragen",
    hint: "Ook aanvragen die nog niet op een factuur staan krijgen de nieuwe prijs.",
  },
  {
    value: PRICE_SCOPE_NEW,
    label: "Alleen nieuwe aanvragen, vanaf nu",
    hint: "Aanvragen die er al liggen houden de oude prijs.",
  },
];

const PriceScopeChoice = ({ value, onChange, disabled }) => (
  <div className="rounded bg-[#FFF7D6] px-3 py-3 text-sm text-[#7F5F01]">
    <p className="flex items-start gap-2 font-medium">
      <FeatherIcon icon="alert-triangle" size={16} className="mt-0.5 shrink-0" />
      <span>De prijs is gewijzigd. Voor welke aanvragen geldt de nieuwe prijs?</span>
    </p>
    <div className="mt-2 space-y-2 pl-6">
      {OPTIONS.map((o) => (
        <label key={o.value} className="flex items-start gap-2 text-sm">
          <input
            type="radio"
            name="price-scope"
            checked={value === o.value}
            onChange={() => onChange(o.value)}
            disabled={disabled}
            className="mt-0.5 h-4 w-4 border-line text-brand focus:ring-0"
          />
          <span>
            <span className="font-medium text-ink">{o.label}</span>
            <span className="block text-xs text-ink-subtlest">{o.hint}</span>
          </span>
        </label>
      ))}
    </div>
    <p className="mt-2 pl-6 text-xs text-ink-subtlest">
      Bestaande facturen veranderen niet, ook concepten niet.
    </p>
  </div>
);

export default PriceScopeChoice;
